/**
 * Client-side mirror of the template's `project_slug` default (copier.yml):
 * lowercase, spaces/underscores → dashes, strip other chars, collapse and trim
 * dashes. Lets the wizard preview the slug live as the name is typed; copier
 * computes the same value server-side.
 */
export function slugify(name: string): string {
  return name
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/_/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
}
